<div class="min-h-screen flex items-center justify-center">
  <form [formGroup]="loginForm" (ngSubmit)="onLogin()" class="bg-base-100 rounded-lg shadow-md p-8 w-full w-[25rem] space-y-6">
    <h2 class="text-xl font-semibold text-center text-primary mb-4">Sign In</h2>
    
    <div class="flex flex-col gap-1">
      <label for="email" class="font-medium">Email</label>
      <input 
        pInputText
        id="email"
        type="email"
        formControlName="email"
        class="input input-bordered w-full"
        placeholder="email"
      />
      <span *ngIf="email?.invalid && (email?.dirty || email?.touched)" class="text-error text-xs">
        <span *ngIf="email?.errors?.['required']">Email is required.</span>
        <span *ngIf="email?.errors?.['email']">Enter a valid email address.</span>
      </span>
    </div>
    
    <div class="flex flex-col gap-1">
      <label for="password" class="font">Password</label>
      <p-password
        formControlName="password"
        [feedback]="false"
        [toggleMask]="true"
        inputClass="input input-bordered w-full"
        id="password"
        placeholder="password"
      ></p-password>
      <span *ngIf="password?.invalid && (password?.dirty || password?.touched)" class="text-error text-xs">
        <span *ngIf="password?.errors?.['required']">Password is required.</span>
        <span *ngIf="password?.errors?.['minlength']">Min 6 characters.</span>
      </span>
    </div>
    
    <button 
      pButton
      type="submit"
      class="btn btn-primary w-full mt-2"
      label="Sign In"
      [disabled]="loginForm.invalid || loading"
    >{{ loading ? "Signing in..." : "Sign In" }}</button>
  </form>
</div>
